import React, { useState, useEffect } from 'react';
import BrandLogo from './BrandLogo';
import './Navbar.css';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Close mobile menu on link click
  const closeMenu = () => setMenuOpen(false);

  // Prevent body scroll when menu is open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
  }, [menuOpen]);

  return ( 
    <>
      <nav className={`nav ${scrolled ? 'scrolled' : ''}`}>
        <BrandLogo className="nav__logo nav__logo--image" size="nav" />
        <a href="/" className="nav__logo nav__logo--text">
          BEYON<span>DIGITAL</span>
        </a>

        <ul className="nav__links">
          <li><a href="#home">Home</a></li>
          <li><a href="#services">Services</a></li>
          {/* <li><a href="#work">Work</a></li> */}
          <li><a href="#about">About</a></li>
          <li><a href="/brochure/index.html">Brochure</a></li>
          <li><a href="#contact">Contact</a></li>
        </ul>

        <a href="#contact" className="btn btn--nav">Start a Project</a>

        <button
          className={`nav__burger ${menuOpen ? 'open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </nav>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${menuOpen ? 'open' : ''}`}>
        <ul>
          <li><a href="#services" onClick={closeMenu}>Services</a></li>
          <li><a href="#work" onClick={closeMenu}>Work</a></li>
          <li><a href="#about" onClick={closeMenu}>About</a></li>
          <li><a href="/brochure/index.html" onClick={closeMenu}>Brochure</a></li>
          <li><a href="#contact" onClick={closeMenu}>Contact</a></li>
        </ul>
        <a href="#contact" className="btn btn--white" onClick={closeMenu}>
          Start a Project
        </a>
      </div>
    </>
  );
}